module.exports = __webpack_public_path__ + "img/ad-img.53255fb1.png";